module.exports = __webpack_public_path__ + "static/media/kw.33b3292e.svg";